<template>
    <div>
        <b-card-body>
            <b-card class="user-password">
                <b-form submit.stop.prevent="save">
                    <!-- <p><b>Simulador - Configuração de comunicação</b></p>
            <BR /> -->
                    <b-row>
                        <b-col sm="12">
                            <b-form-group :label="$t('periodo-grafico-ocorrencias')" label-for="graphPeriod">
                                <b-form-input class="input-pentagro" id="graphPeriod" type="number"
                                    v-model="intervalDaysForGraph" name="ociosidade" v-validate="{
                                        required: true,
                                        numeric: true,
                                        min_value: 0,
                                    }" :state="validateState('graphPeriod')" aria-describedby="graphPeriod-feedback"
                                    placeholder="Informe o período em horas" />
                                <b-form-invalid-feedback id="graphPeriod-feedback">{{
                                    veeErrors.first("graphPeriod")
                                    }}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="groupBtn">
                        <div>
                            <img src="@/assets/salvar.png" :alt="$t('salvar')" style="margin-left: 30px;"
                                :title="$t('salvar')" @click="save" />
                            <img src="@/assets/atualizar.png" style="margin-left: 30px;" :title="$t('limpar')"
                                :alt="$t('limpar')" @click="resetForm" />
                            <img id="closeModalPassword" class="float-right" src="@/assets/sair.png"
                                style="margin-left: 30px;" :title="$t('sair')" :alt="$t('sair')"
                                @click="$bvModal.hide('modalGraphTime')" />
                        </div>
                    </b-row>
                </b-form>
            </b-card>
        </b-card-body>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import axios from "axios";


export default {
    name: "IdleTime",
    computed: mapState(["user"]),
    data: function () {
        return {
            intervalDaysForGraph: 0,
            backupInterval: 0,
        };
    },
    methods: {
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        save() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    showError(this.$t('campos-com-preenchimento-obrigatorio'));
                    return;
                } else {
                    axios["post"](`${urlMainAPI}/savegraphoccurrenceperiod/`, JSON.stringify(this.intervalDaysForGraph), { headers: { 'Content-Type': 'application/json' } })
                        .then(res => {
                            this.$nextTick(() => {
                                this.$validator.reset();
                            });
                            defaultSuccess(res.data);
                            this.backupInterval = parseInt(this.intervalDaysForGraph);
                            this.$bvModal.hide('modalGraphTime');
                        })
                        .catch(() => {
                            this.resetForm();
                        });
                }
            });
        },
        loadSystemConfig() {
            const url = `${urlMainAPI}/getsystemconfiguration`
            axios
                .get(url)
                .then(res => {
                    this.intervalDaysForGraph = parseInt(res.data.intervalDaysForGraph)
                    this.backupInterval = parseInt(res.data.intervalDaysForGraph)
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                })
        },
        resetForm() {
            this.$nextTick(() => {
                this.$validator.reset();
            });
            this.reset();
        },
        reset() {
            this.intervalDaysForGraph = parseInt(this.backupInterval)
        }
    },
    created() {
        this.$validator.localize("pt_BR");
        this.loadSystemConfig()
    }
};
</script>

<style scoped>
.user-password {
    max-width: 600px;
}

.groupBtn {
    display: flex;
    justify-content: flex-end;
    margin-right: 5px;
}

img {
    max-height: 35px;
}
</style>